import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.91016 7.90918C6.91016 7.35689 7.35787 6.90918 7.91016 6.90918H30.092C30.6443 6.90918 31.092 7.35689 31.092 7.90918V11.091C31.092 11.6433 30.6443 12.091 30.092 12.091H7.91016C7.35787 12.091 6.91016 11.6433 6.91016 11.091V7.90918ZM6.91016 18.2728C6.91016 17.7205 7.35787 17.2728 7.91016 17.2728H30.092C30.6443 17.2728 31.092 17.7205 31.092 18.2728V21.4546C31.092 22.0069 30.6443 22.4546 30.092 22.4546H7.91016C7.35787 22.4546 6.91016 22.0069 6.91016 21.4546V18.2728ZM7.91016 27.6365C7.35787 27.6365 6.91016 28.0842 6.91016 28.6364V31.8183C6.91016 32.3706 7.35787 32.8183 7.91016 32.8183H30.092C30.6443 32.8183 31.092 32.3706 31.092 31.8183V28.6365C31.092 28.0842 30.6443 27.6365 30.092 27.6365H7.91016Z",
  fill: "#475F7B"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_1612_31762",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "6",
  y: "6",
  width: "26",
  height: "27"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.91016 7.90918C6.91016 7.35689 7.35787 6.90918 7.91016 6.90918H30.092C30.6443 6.90918 31.092 7.35689 31.092 7.90918V11.091C31.092 11.6433 30.6443 12.091 30.092 12.091H7.91016C7.35787 12.091 6.91016 11.6433 6.91016 11.091V7.90918ZM6.91016 18.2728C6.91016 17.7205 7.35787 17.2728 7.91016 17.2728H30.092C30.6443 17.2728 31.092 17.7205 31.092 18.2728V21.4546C31.092 22.0069 30.6443 22.4546 30.092 22.4546H7.91016C7.35787 22.4546 6.91016 22.0069 6.91016 21.4546V18.2728ZM7.91016 27.6365C7.35787 27.6365 6.91016 28.0842 6.91016 28.6364V31.8183C6.91016 32.3706 7.35787 32.8183 7.91016 32.8183H30.092C30.6443 32.8183 31.092 32.3706 31.092 31.8183V28.6365C31.092 28.0842 30.6443 27.6365 30.092 27.6365H7.91016Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_1612_31762)" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };